export default function ScrollPill({ text = 'Scroll for more' }: { text?: string }) {
	return (
		<div
			aria-hidden="true"
			className="absolute bottom-4 left-1/2 -translate-x-1/2 pointer-events-none"
		>
			<span className="inline-flex items-center gap-1.5 bg-white/90 backdrop-blur-sm border border-gray-200 rounded-full px-4 py-2 text-xs font-medium text-gray-500 shadow-sm">
				{text}
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 16 16"
					fill="currentColor"
					className="w-3 h-3"
				>
					<path
						fillRule="evenodd"
						d="M8 2a.75.75 0 01.75.75v8.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 011.06-1.06l3.22 3.22V2.75A.75.75 0 018 2z"
						clipRule="evenodd"
					/>
				</svg>
			</span>
		</div>
	)
}
